// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout--ullevT0y","layoutMain":"layoutMain--WMze4LRg"};